import { useEffect, useSyncExternalStore } from 'react';

/**
 * The number of "Att göra nu" items, for the badge on "Att göra" in the phone's
 * bottom bar. The home pages work the list out and report it here, so the badge
 * shows once the home page has been opened in this session (null until then).
 */
let count: number | null = null;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

export function setTodoCount(next: number | null) {
  if (next === count) return;
  count = next;
  listeners.forEach(listener => listener());
}

export function useTodoCount(): number | null {
  return useSyncExternalStore(subscribe, () => count);
}

/** Reports the home page's to-do count; null while it is still loading. */
export function useReportTodoCount(value: number | null) {
  useEffect(() => { setTodoCount(value); }, [value]);
}
